// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/dynamic-form-picklist-item-definition-schema',
  type: 'object',
  required: ['id', 'order'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      minLength: 1,
    },
    caption: {
      type: 'string',
      nullable: true,
    },
    order: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
